import { FC } from 'react';
import image from './emoji-png/start.png';

export const EmojiStartIcon: FC<any> = ({ ...props }) => (
  <img src={image} width="32px" height="32px" alt="Start icon" {...props} />
);
